import Step from "./Step";

class Step1 extends Step {
    constructor() {
        super(1, 'account', $(`[data-register-step="account"]`));
        if (this.element.length === 0) {
            console.error('Step 1 element not found!');
        }
        this.form = this.element.find('#register_form');
        this.validateForm = this.element.find('#validate_form');
        this.passwordMeter = null;
        this.createAccountButton = null;

        // Form elements
        this.emailRegistrationForm = this.element.find('#email_registration_form');

        this.validator = null;
        this.validator_config = {
            fields: {
                firstname: {
                    validators: {
                        notEmpty: {
                            message: translations.firstname_required
                        }
                    }
                },
                lastname: {
                    validators: {
                        notEmpty: {
                            message: translations.lastname_required
                        }
                    }
                },
                email: {
                    validators: {
                        regexp: {
                            regexp: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: translations.not_valid_email,
                        },
                        notEmpty: {
                            message: translations.email_required
                        },
                        remote: {
                            message: translations.accountexists,
                            url: '/register/checkemail',
                            delay: 500
                        }
                    }
                },
                toc: {
                    validators: {
                        notEmpty: {
                            message: translations.terms
                        }
                    }
                },
                password: {
                    validators: {
                        notEmpty: {
                            message: translations.password_required,
                        },
                        callback: {
                            message: translations.password_required_strength,
                            callback: (input) => {
                                return this.validatePassword();
                            }
                        }
                    }
                },
                confirm: {
                    validators: {
                        notEmpty: {
                            message: translations.password_required2,
                        },
                        identical: {
                            compare: (input) => {
                                return this.form.find('[name="password"]').val();
                            },
                            message: translations.password_required2_identical,
                        },
                    },
                }

            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger({
                    event: {
                    }
                }),
                bootstrap: new FormValidationBootstrap5({
                    rowSelector: '.fv-row',
                })
            }
        };
    }

    validatePassword() {
        return (this.passwordMeter.getScore() > 50);
    }

    init() {
        console.log('Step1 init: Account details');
        // Initialize form components - email form is always visible via PHP
        if (!this.passwordMeter) {
            this.passwordMeter = new KTPasswordMeter(document.querySelector('#password_meter'));
        }
        if (!this.validator) {
            this.validator = FormValidation.formValidation(this.form[0], this.validator_config);
        }
        if (!this.createAccountButton) {
            this.createAccountButton = this.form.find('#create_account_button');
            this.createAccountButton.off('click').on('click', (e) => {
                e.preventDefault();
                this.registerUser();
            });
        }
    }


    async registerUser() {
        this.validator.revalidateField('password');
        this.validator.validate().then(async (status) => {
            if (status === 'Valid') {
                // block all inputs
                this.form.find('input').prop('disabled', true);
                this.createAccountButton.attr('data-kt-indicator', 'on');

                let data = await API.post("/register", {
                    firstname: this.form.find('[name="firstname"]').val(),
                    lastname: this.form.find('[name="lastname"]').val(),
                    email: this.form.find('[name="email"]').val(),
                    password: this.form.find('[name="password"]').val(),
                    password2: this.form.find('[name="confirm"]').val(),
                    toc: this.form.find('[name="toc"]').prop('checked'),
                    'g-recaptcha-response': this.form.find('[name="g-recaptcha-response"]').val(),
                });

                if (data.status === 200) {
                    // Update CSRF token in meta tag to prevent mismatch after session regeneration
                    if (data.csrf_token) {
                        $('meta[name="csrf-token"]').attr('content', data.csrf_token);
                    }
                    window.register.initUser(data.authUser);
                    window.register.goNext();
                } else if (data.error) {
                    message.error(data.error.responseJSON.message);
                    this.createAccountButton.attr('data-kt-indicator', 'off');
                    this.form.find('input').prop('disabled', false);
                }
            }
        });
    }



    async isComplete() {
        return false;
    }
}

export default Step1;